import { render, staticRenderFns } from "./miscellaneous-certification.component.vue?vue&type=template&id=3d8b66e6&scoped=true"
import script from "./miscellaneous-certification.component.ts?vue&type=script&lang=ts&external"
export * from "./miscellaneous-certification.component.ts?vue&type=script&lang=ts&external"
import style0 from "./miscellaneous-certification.component.vue?vue&type=style&index=0&id=3d8b66e6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8b66e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d8b66e6')) {
      api.createRecord('3d8b66e6', component.options)
    } else {
      api.reload('3d8b66e6', component.options)
    }
    module.hot.accept("./miscellaneous-certification.component.vue?vue&type=template&id=3d8b66e6&scoped=true", function () {
      api.rerender('3d8b66e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/miscellaneous-certification/miscellaneous-certification.component.vue"
export default component.exports